import { useEffect } from "react";
import "./assets/css/Style.css";
import "./assets/css/Form-element.css";
import imgdelete from "./assets/img/delete.png";
import backarrowwhite from "./assets/img/back-arrow-white.svg";
import logoblue from "./assets/img/questmath-logo-blue.png";

export default function Login() {
  useEffect(() => {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    console.log("Height: " + vh);
  }, []);

  return (
    <>
      <div className="main-container shortDistance bgchange">
        <div className="inner-container left-container left-bg">
          <div className="curve-container">
            <div className="back_button">
              <img src={backarrowwhite} />
            </div>
            <div className="register-container">
              <div className="register-titles">
                <div className="register-title">Login to your account</div>
              </div>
              <div className="form-row-custom">
                <label className="custom-label">Username</label>
                <input
                  type="text"
                  className="custom-field"
                  placeholder="Enter your username"
                  value=""
                />
              </div>
              <div className="form-row-custom">
                <label className="custom-label">Password</label>
                <input
                  type="password"
                  className="custom-field"
                  placeholder="Enter your password"
                  value=""
                />
              </div>
              <div className="form-row-custom register-form-btn mb-0">
                <button className="quest-btn quest-primary-btn">Login</button>
                <div className="custom-link">
                  Don't have an account? <a href="/" >Click Here</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="inner-container right-container right-bg">
          <div className="register-right-container">
            <div className="register-right-titles">
              <div className="register-right-sub-title">Welcome to </div>
              <div className="register-right-title">
                <img
                  src={logoblue}
                  className="img-fluid"
                  alt="QuestMath Blue Logo"
                />
              </div>
            </div>
            <div className="register-features-container hideinsmallscreen">
              <div className="register-features-row">
                <div className="feature-card">
                  <div className="feature-title">
                    INDIVIDUAL ATTENTION
                    <br />
                    <span>1 : 1 className with mentor</span>
                  </div>
                  <div className="icon-container">
                    <img src={imgdelete} className="img-fluid" />
                  </div>
                </div>
              </div>
              <div className="register-features-row card-right">
                <div className="feature-card">
                  <div className="icon-container">
                    <img src={imgdelete} className="img-fluid" />
                  </div>
                  <div className="feature-title">
                    EXCLUSIVE WORKOUTS
                    <br />
                    <span>Practice workoouts for free</span>
                  </div>
                </div>
              </div>
              <div className="register-features-row">
                <div className="feature-card">
                  <div className="feature-title">
                    UNLOCK REWARDS
                    <br />
                    <span>Earn rewards while learning</span>
                  </div>
                  <div className="icon-container">
                    <img src={imgdelete} className="img-fluid" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
